module.exports = __webpack_public_path__ + "img/Nora-logo_small.7314f5.png";